import BasicButton from "components/BasicInputs/BasicButton";
import { useFormikContext } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/store";
import { MaterialSchema } from "../validation";
import { appSetAlert } from "store/actions/appAction";
import { apiSaveManufactureFormula, apiUpdateManufactureFormula } from "api/manufactureFormulaApi";
import { useState } from "react";

export default function Footer() {
  const dispatch = useAppDispatch();
  const store = useAppSelector((x) => x);
  const navigate = useNavigate();
  const data = useFormikContext<MaterialFormulaData>();
  const token = store?.businessReducer?.business?.token;
  const { id } = useParams() ?? { id: undefined };
  const [isSubmitClicked, setSubmitClicked] = useState(false);

  return (
    <div className="sticky bottom-0 z-[3] flex items-center justify-between w-full p-4 bg-white rounded-md shadow-proportional">
      <div className="flex items-center gap-4"></div>
      <div>
        <BasicButton
          variant="contained"
          disabled={isSubmitClicked}
          onClick={() => {
            setSubmitClicked(true);
            const isValid = MaterialSchema.safeParse(data.values);
            if (!isValid.success) {
              dispatch(appSetAlert("موارد ضروری را وارد کنید", "error"));
              setSubmitClicked(false);
              return;
            }

            if (data.values.isEdit) {
              if (id === undefined) return;
              dispatch(
                apiUpdateManufactureFormula(id, data.values, token, navigate, () => {
                  setSubmitClicked(false);
                })
              );
            } else {
              dispatch(
                apiSaveManufactureFormula(data.values, token, navigate, () => {
                  setSubmitClicked(false);
                })
              );
            }
          }}
        >
          <span>{data.values.isEdit ? "ثبت تغییرات" : "ثبت نهایی"}</span>
        </BasicButton>
      </div>
    </div>
  );
}
